<template>
  <div ref="box" class="book-bg">
  <div v-if="scrolldisabled" class="flipbook" @wheel.prevent="true">
  <img class="book-img" :src="images[currentIndex]" />
  </div>
  <div v-else class="flipbook">
  <img class="book-img" :src="images[currentIndex]" />
  </div>
 </div>
  <div ref="pics" class="home" @wheel.prevent="true">
    <div class="swiper">
      <div :class="['page1',pageclass]" :style="{transform:pageIndex <= 1 ? 'translate3d(0, 0, 0)' :'translate3d(0, -100%, 0)',zIndex:6}">
        <img class="home-pic" src="https://static.igem.wiki/teams/5298/assets/homepic-1.gif" style="width:35vw;margin-left: 1vw;margin-bottom: 20vh;margin-right: 3vw">
        <div :class="[wordAniamtion1]">
        <p>Nailiva embraces the philosophy of "drawing inspiration</p>
        <p>from nature and giving back to it through synthetic biology."</p>
        </div>
      </div>
      <div :class="['page2',pageclass]" :style="{transform:pageIndex <= 2 ? 'translate3d(0, 0, 0)' :'translate3d(0, -100%, 0)',zIndex:5}">
        <div style="margin-left: 6vw;margin-right: 4vw;" :class="[wordAniamtion2]">
        <p>By developing healthier, safer, and more sustainable nail</p>
        <p>materials, we aim to drive progress and innovation within</p>
        <p>the industry.</p>
        </div>
       <img class="home-pic" src="https://static.igem.wiki/teams/5298/assets/homepic-2.gif" style="width:40vw">
      </div>
      <div :class="['page3',pageclass]" :style="{transform:pageIndex <= 3 ? 'translate3d(0, 0, 0)' :'translate3d(0, -100%, 0)',zIndex:4}">
        <p :class="[wordAniamtion3]" style="margin-left: 3vw;margin-top: 25vh;">We are dedicated to seamlessly blending life sciences with art.</p>
      </div>
      <div :class="['page4',pageclass]" :style="{transform:pageIndex <= 4 ? 'translate3d(0, 0, 0)' :'translate3d(0, -100%, 0)',zIndex:3}">
        <p :class="[wordAniamtion4]" style="margin-left: 35vw;margin-top: 35vh;">Expanding the concept and dimensions of beauty.</p>
      </div>
      <div :class="['page5',pageclass]" :style="{transform:pageIndex <= 5 ? 'translate3d(0, 0, 0)' :'translate3d(0, -100%, 0)',zIndex:2}">
        <p :class="[wordAniamtion5]" style="margin-left: 5vw;margin-top: 20vh;color: white;">Raising awareness of synthetic biology and the beauty of life itself.</p>
      </div>
    </div>
  </div>
  <div ref="video" style="margin-left: auto;margin-right:auto;width:60vw;margin-bottom: 5vh;margin-top: 10vh">
    <iframe style="width:60vw;height:35vw" title="Tongji-China: Nailiva: an innovative and healthy bio-art nail (2024) - Project Promotion [English]" src="https://video.igem.org/videos/embed/bab47364-de96-491a-b629-852a129a2aa6" frameborder="0" allowfullscreen="" sandbox="allow-same-origin allow-scripts allow-popups allow-forms"></iframe>
    </div>
</template>
 
<script>
import {defineComponent,onMounted, ref } from 'vue';
 
export default defineComponent({
  name: 'Home',
   data() {
    return {
      images: [
        'https://static.igem.wiki/teams/5298/assets/part-1.gif',
        'https://static.igem.wiki/teams/5298/assets/part-2.webp',
        'https://static.igem.wiki/teams/5298/assets/part-3.gif',
        'https://static.igem.wiki/teams/5298/assets/part-4.gif',
        ]
    }
  },
  setup() {  
    const pageclass = ref('page')
    let currentIndex = ref(0)
    let pageIndex = ref(0)
    let scrolldisabled = ref(false)
    const picsdisabled=ref(false)
    const wordAniamtion1 = ref('')
    const wordAniamtion2 = ref('')
    const wordAniamtion3 = ref('')
    const wordAniamtion4 = ref('')
    const wordAniamtion5 = ref('')

    const box = ref(null)
      const pics = ref(null)
    const video=ref(null)

     //函数防抖
    const debounce = (func, wait) =>{
        let timeout;
        return  function() {
            let context = this;
            let args = arguments;
            if (timeout) clearTimeout(timeout);
            timeout = setTimeout(() => {
                func.apply(context, args)
            }, wait);
        }
    }

    const methodA = (e) => {
          if (scrolldisabled.value) {
              console.log('滑动')
              if (e.deltaY > 0 && currentIndex.value == 3) { //  下一张  最后一张
                currentIndex.value = 0;
                pageIndex.value = 0;
                  scrolldisabled.value = false;
              } else if (e.deltaY > 0 && currentIndex.value != 3) {//  下一张    不等于最后一张
                  currentIndex.value++
              } else if (e.deltaY < 0 && currentIndex.value != 0) {//  上一张 不等于第一张
                  currentIndex.value--
              } else if (e.deltaY < 0 && currentIndex.value == 0) { //  上一张 第一张
                  currentIndex.value = 0;
                  scrolldisabled.value = false;
              } else {
                  return
              }
          }
        }

    // 滚轮监听
    const methodB = (e) => {
      if (picsdisabled.value) {
        console.log('滚动')
        if (pageIndex.value == 5 && e.deltaY < 0) {
          pageclass.value = 'fixpage'
        }
          if (e.deltaY > 0 && pageIndex.value == 5) { //  下一张  最后一张
            setTimeout(() => {
              pageclass.value = 'page'
              picsdisabled.value = false
            video.value.scrollIntoView({ behavior: 'smooth', block: 'center' });
            //scrolldisabled.value = true
          }, 500);
        } else if (e.deltaY > 0 && pageIndex.value != 5) {//  下一张    不等于最后一张
            pageIndex.value++
        } else if (e.deltaY < 0 && pageIndex.value != 1) {//  上一张 不等于第一张
          pageIndex.value--
        } else if (e.deltaY < 0 && pageIndex.value == 1) { //  上一张 第一张
            picsdisabled.value = false
            setTimeout(() => {
              pageclass.value = 'page'
              pageIndex.value = 0
              box.value.scrollIntoView({ behavior: 'smooth', block: 'end' });
              scrolldisabled.value = true
          }, 300);
        } else {
          return
        }
        if (pageIndex.value == 1) {
          setTimeout(() => {
            wordAniamtion1.value = 'animate__animated animate__bounceIn'
            setTimeout(() => {
              wordAniamtion1.value = ''
            }, 1000);
          }, 300);
        }
        else if (pageIndex.value == 2) {
          setTimeout(() => {
            wordAniamtion2.value = 'animate__animated animate__flipInX'
            setTimeout(() => {
              wordAniamtion2.value = ''
            }, 1000);
          }, 300);
        }
        else if (pageIndex.value == 3) {
          setTimeout(() => {
            wordAniamtion3.value = 'animate__animated animate__lightSpeedInLeft'
            setTimeout(() => {
              wordAniamtion3.value = ''
            }, 1000);
          }, 300);
        }
        else if (pageIndex.value == 4) {
          setTimeout(() => {
            wordAniamtion4.value = 'animate__animated animate__jackInTheBox'
            setTimeout(() => {
              wordAniamtion4.value = ''
            }, 1000);
          }, 300);
        }
        else if (pageIndex.value == 5) {
          setTimeout(() => {
            wordAniamtion5.value = 'animate__animated animate__zoomIn'
            setTimeout(() => {
              wordAniamtion5.value = ''
            }, 1000);
          }, 300);
        }
      }
    }
    
    onMounted(() => {
      window.addEventListener('mousewheel', debounce(methodA, 500), true)
      window.addEventListener('mousewheel', debounce(methodB, 500), true)
      const observer = new IntersectionObserver((entries) => {
              entries.forEach((entry) => {
                  if (entry.isIntersecting) {
                    // 当元素进入视窗口时触执行这里面的代码
                    if (entry.target === pics.value) {
                      console.log('图片进入视口')
                      scrolldisabled.value=false
                        picsdisabled.value = true
                        pageclass.value = 'fixpage'
                    } else {
                      setTimeout(() => {
                          box.value.scrollIntoView({ behavior: 'smooth', block: 'end' });
                          scrolldisabled.value=true
                      }, 500);
                    }
                  } else {
                    if (entry.target === box.value) {
                      scrolldisabled.value=false
                    }
                  }
            });
            }, { threshold: 0.2 });

            observer.observe(box.value);
            observer.observe(pics.value);
    });

    return {
      pageIndex,
      currentIndex,
      pageclass,
      wordAniamtion1,
      wordAniamtion2,
      wordAniamtion3,
      wordAniamtion4,
      wordAniamtion5,
      box,
        pics,
      video,
      scrolldisabled    
    }
  }
})
</script>
<style scoped>
.home {
  width: 100%;
  height: 93.5vh;
  overflow: hidden;
  position: relative;
  opacity: 1;
  .page {
    width: 100%;
    height: 93.5vh;
    background-size: 100% 100%;
    display: flex;
    align-items: center;
    font-size: 1.9vw;
    font-weight: bold;
    font-family:Arial, Helvetica, sans-serif;
    color: black;
    position: absolute;
    transition: transform 1s;
  }
  .fixpage{
    width: 100%;
    height: 93.5vh;
    background-size: 100% 100%;
    display: flex;
    align-items: center;
    font-size: 1.8vw;
    line-height: 3vw;
    font-weight: bold;
    font-family:Arial, Helvetica, sans-serif;
    color: black;
    transition: transform 1s;
    position: fixed;
    bottom: 0;
  }
  .page1{
     background-color: #F6F4E7;
  }
  .page2{
     background-color: #F6F4E7;
  }

  .page3{
    width: 100%;
    height: 93.5vh;
    background-size: 100% 100%;
    background-image: url(https://static.igem.wiki/teams/5298/assets/homepic-3.jpg)
  }
  .page4{
    width: 100%;
    height: 93.5vh;
    background-size: 100% 100%;
    background-image: url(https://static.igem.wiki/teams/5298/assets/homepic-4.jpg)
  }
  .page5{
    width: 100%;
    height: 93.5vh;
    background-size: 100% 100%;
    background-image: url(https://static.igem.wiki/teams/5298/assets/homepic-5.jpg)
  }
}

 .swiper{
    overflow: hidden;
    touch-action: none;
  }

  .book-bg{
    width: 100vw;
    height: 94vh;
    overflow: hidden;
    position: relative;
    opacity: 1;
    .flipbook{
        width:100vw;
        height: 93.5vh;
        margin-left: auto;
        margin-right: auto;
        background: url(https://static.igem.wiki/teams/5298/assets/bookbg.png) no-repeat;
        background-size:65% 100%;
        background-position:center center;
        display: flex;
        justify-content: center; /* 水平居中 */
        align-items: center;    /* 垂直居中 */
    }
}


.book-img{
  width:55vw;
}
</style>